import React from "react";
import styled from "styled-components";
import { Text as RText } from "rebass/styled-components";
import BaseComponent from "../Base/BaseComponent";
import headingStyles from "./headingStyles";
import LogEvent from "../../log/LogEvent";
import Flex from "../Flex/Flex";
import FAIcon from "../Icon/FAIcon";

const Text = (props) => <BaseComponent data-testid={props.testid} {...props} />;

Text.defaultProps = {
  color: "fullShade",
  as: RText,
};

const Body = ({ medium, small, extraSmall, ...props }) => <Text fontWeight={medium ? "medium" : "regular"} fontSize={extraSmall ? 12 : small ? 14 : 16} lineHeight="24px" letterSpacing="-0.08px" {...props} />;

const createHeadingComponent = (name) => {
  const Component = (props) => (
    <LogEvent logEventProps={props.logEventProps} actionProps={{ onClick: { action: "click" } }} elementType="Text">
      <Text {...headingStyles[name]} {...props} />
    </LogEvent>
  );
  Component.displayName = name;
  Component.propTypes = Text.propTypes;
  return Component;
};

const TextButton = styled(Flex)`
  &:hover {
    opacity: 0.8;
  }
`;

/**
 * Text button link.
 * @param onClick
 * @param text
 * @param icon
 * @param iconProps
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const TextLink = ({ onClick, text, icon = null, iconProps, textProps, ...props }) => (
  <TextButton id={`textlink-id-${text.replace(/ /g, "-")}`} data-testid={`textlink-id-${text.replace(/ /g, "-")}`} alignItems="center" hover={{ opacity: 0.6 }} cursor="pointer" onClick={onClick} fontSize={13} fontWeight="500" {...props}>
    {icon && (
      <FAIcon
        icon={icon}
        color="primary"
        fontWeight="900"
        style={{
          fontSize: 12,
          fontWeight: 500,
          marginRight: 4,
          color: "primary",
        }}
        {...iconProps}
      />
    )}
    <Text color="primary" {...textProps}>
      {text}
    </Text>
  </TextButton>
);

const H1 = createHeadingComponent("H1");
const H2 = createHeadingComponent("H2");
const H3 = createHeadingComponent("H3");
const H4 = createHeadingComponent("H4");
const H5 = createHeadingComponent("H5");
const H6 = createHeadingComponent("H6");

export { Text, TextLink, Body, H1, H2, H3, H4, H5, H6 };
